import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import { Provider } from "react-redux";
// import { PersistGate } from "redux-persist/integration/react";
// import store, { persistor } from "./store/store/index";

import { Provider } from "react-redux";
import store from "./store/store/index";
import { initClarity } from "./utils/clarity";

// Initialize Microsoft Clarity
initClarity();

createRoot(document.getElementById("root")).render(
  // <Provider store={store}>
  //   <PersistGate loading={null} persistor={persistor}>
  //     <App />
  //     <ToastContainer />
  //   </PersistGate>
  // </Provider >,

  <Provider store={store}>
    <HashRouter>
      <App />
      <ToastContainer />
    </HashRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//  "lint": "eslint \"src/**/*.js\"",  -> package.json script line
